import {
    faCheck,
    faClock,
    faEdit,
    faHome,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VerAtendimento from "../../../../Components/CardsPages/Atendimento/VerAtendimento";
import { IAgendaCompromisso } from "../../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import AlertaMaisAtendimentoParaProduto from "./AlertaMaisAtendimentoParaProduto";
import { useState } from "react";
import EditarEventoAgendamento from "../EditarEventoAgendamento";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { MarcarAgendamentoConcluidoController } from "../../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import moment from "moment";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import Swal from "sweetalert2";

interface IDescricaoEventoAgendamentoProps {
    agendamento: IAgendaCompromisso;
    nome_cliente?: string;
    setShow?: (flag: boolean) => void;
    setAtualizaAgenda?: (flag: boolean) => void;
}

export default function DescricaoEventoAgendamento(
    props: IDescricaoEventoAgendamentoProps
) {
    const [flEditar, setFlEditar] = useState(false);

    function endEdit() {
        if (props.setAtualizaAgenda) props.setAtualizaAgenda(true);
        if (props.setShow) props.setShow(false);

        setFlEditar(false);
    }

    const dataDuracao = getDataDuracaoString(
        new Date(props.agendamento.DT_INICIO),
        new Date(props.agendamento.DT_FIM)
    );

    const {
        execute: MarcarAgendamentoConcluido,
        loading: MarcarAgendamentoConcluidoLoading,
    } = useAsyncCallback(MarcarAgendamentoConcluidoController);

    const lstEtapasTipoCaso = [
        {
            nrEtapa: 1,
            color: "red",
        },
        {
            nrEtapa: 2,
            color: "red",
        },
        {
            nrEtapa: 3,
            color: "red",
        },
        {
            nrEtapa: 4,
            color: "black",
        },
        {
            nrEtapa: 5,
            color: "yellow",
        },
        {
            nrEtapa: 6,
            color: "blue",
        },
        {
            nrEtapa: 7,
            color: "purple",
        },
        {
            nrEtapa: 10,
            color: "green",
        },
    ];

    return (
        <div>
            <div className="w-100 d-flex align-items-center justify-content-between font-weight-bolder font-size-h4">
                <span className="d-flex justify-content-center align-items-center">
                    <p className="m-0">
                        {props.agendamento.DS_TIPO_COMPROMISSO}
                    </p>
                    <span
                        className={`ml-2 label ${
                            props.agendamento.NR_ETAPA === null
                                ? "label-dark"
                                : lstEtapasTipoCaso?.find(
                                      (etapaItem) =>
                                          etapaItem.nrEtapa ===
                                          props.agendamento.NR_ETAPA
                                  )?.color
                        }`}
                    ></span>
                </span>
                {!flEditar &&
                    props.agendamento.ID_TIPO_CASO ===
                        ACESSOS.ATENDIMENTO.ID_MODULO && (
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="ver-info-tooltip">
                                    Editar/Transferir Agendamento
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-outline-primary"
                                onClick={() => setFlEditar(true)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                        </OverlayTrigger>
                    )}
            </div>
            <hr />
            {props.agendamento.DS_CONCLUIDO === "CONCLUÍDO" && (
                <div className="d-flex flex-row g-2 align-items-center">
                    <span className="rounded-circle bg-light-success text-success p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                        <FontAwesomeIcon icon={faCheck} />
                    </span>
                    <span>Agendamento concluído</span>
                </div>
            )}
            {flEditar ? (
                <EditarEventoAgendamento
                    agendamento={props.agendamento}
                    endEdit={endEdit}
                />
            ) : (
                <>
                    <div className="my-2">
                        <div className="d-flex flex-row-reverse">
                            <VerAtendimento
                                ID_CASO={props.agendamento.ID_CASO}
                                ID_TIPO_CASO={
                                    props.agendamento.ID_TIPO_CASO
                                        ? props.agendamento.ID_TIPO_CASO
                                        : props.agendamento.DS_ASSUNTO ===
                                          "Agendamento de Vistoria"
                                        ? ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO
                                        : ACESSOS.ASSISTENCIA.ID_MODULO
                                }
                            />
                        </div>
                        <div className="d-flex flex-row g-2 align-items-center">
                            <span className="rounded-circle bg-light-info text-info p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                                <FontAwesomeIcon icon={faUser} />
                            </span>
                            <span>{props.agendamento.DS_NOME}</span>
                        </div>
                        <div className="d-flex flex-row g-2 align-items-center">
                            <span className="rounded-circle bg-light-warning text-warning p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                                <FontAwesomeIcon icon={faClock} />
                            </span>
                            <span>{dataDuracao}</span>
                        </div>
                        <div className="d-flex flex-row g-2 align-items-center">
                            <span className="rounded-circle bg-light-danger text-danger p-2 d-inline-flex align-items-center justify-content-center mr-2 my-1">
                                <FontAwesomeIcon icon={faHome} />
                            </span>
                            <span>
                                {props.agendamento.DS_LOCAL ??
                                    "Empreendimento - Produto - Unidade"}
                            </span>
                        </div>
                    </div>
                    <hr />
                    <div>
                        <div>
                            <span className="font-weight-bolder">Assunto</span>
                            <p className="text-black-50">
                                {props.agendamento.DS_ASSUNTO}
                            </p>
                        </div>
                    </div>
                    <div>
                        <div>
                            <span className="font-weight-bolder">
                                Descrição
                            </span>
                            <p className="text-black-50">
                                {props.agendamento.DS_DESCRICAO}
                            </p>
                        </div>
                    </div>
                    {props.nome_cliente ? (
                        <div>
                            <div>
                                <span className="font-weight-bolder">
                                    Cliente
                                </span>
                                <p className="text-black-50">
                                    {props.nome_cliente}
                                </p>
                            </div>
                        </div>
                    ) : null}
                    {props.agendamento.ID_CASO && (
                        <AlertaMaisAtendimentoParaProduto
                            ID_COMPROMISSO={props.agendamento.ID_COMPROMISSO}
                        />
                    )}
                </>
            )}
            {props.agendamento.DS_CONCLUIDO?.toUpperCase() !== "CONCLUÍDO" && (
                <div className="d-flex justify-content-end align-items-center">
                    <button
                        className="btn btn-success"
                        onClick={() => {
                            Swal.fire({
                                title: `Deseja concluir esse agendamento?`,
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    MarcarAgendamentoConcluido(
                                        props.agendamento.ID_COMPROMISSO,
                                        moment(new Date()).format(
                                            "YYYY-MM-DD HH:mm:ss"
                                        )
                                    ).then(() => {
                                        if (props.setAtualizaAgenda)
                                            props.setAtualizaAgenda(true);
                                        if (props.setShow) props.setShow(false);
                                    });
                                }
                            });
                        }}
                    >
                        {MarcarAgendamentoConcluidoLoading ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faCheck} />
                        )}{" "}
                        Marcar como concluído
                    </button>
                </div>
            )}
        </div>
    );
}

function getDataDuracaoString(dataInicio: Date, dataFim: Date) {
    if (
        dataInicio.getDate() === dataFim.getDate() &&
        dataInicio.getMonth() === dataFim.getMonth() &&
        dataInicio.getFullYear() === dataFim.getFullYear()
    )
        return `${dataInicio.toLocaleDateString()} -  ${dataInicio.toLocaleTimeString()} às ${dataFim.toLocaleTimeString()}`;
    else
        return `${dataInicio.toLocaleDateString()} ${dataInicio.toLocaleTimeString()} às ${dataFim.toLocaleDateString()} ${dataFim.toLocaleTimeString()}`;
}
